import React, { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { subscribe, unsubscribe } from "../../../../eventBus";
import * as Validator from "../requestSubmissionValidator";
import AddDocument from "./AddDocument";
import Document from "./Document";
import DocumentTitle from "./DocumentTitle";
import DocumentUploadButton from "./DocumentUploadButton";
import DocumentUploadProgress from "./DocumentUploadProgress";

export const UPLOAD_STATUS = {
  NOT_STARTED: 0,
  IN_PROGRESS: 1,
  ERROR: 2,
  TIMEOUT: 3,
  SUCCESS: 4,
};

export const statusColor = (status) => {
  switch (status) {
    case UPLOAD_STATUS.ERROR:
    case UPLOAD_STATUS.TIMEOUT:
      return "red";
    case UPLOAD_STATUS.IN_PROGRESS:
      return "yellow";
    case UPLOAD_STATUS.SUCCESS:
      return "green";
    default:
      return "grey";
  }
};

function DocumentUpload({
  dispatchUpdateAction,
  documents,
  minDocumentsAttached,
  acceptDocumentTypes,
  maxDocumentSizeInMb,
  className = "",
  uploadUrl = `${process.env.REACT_APP_GATEWAY_URL}/upload`,
  handleResponse,
  titleSize = 20,
  formDataAsJson = {},
}) {
  const { t } = useTranslation();

  const validate = useCallback(() => {
    return {
      valid: Validator.minDocumentsAttached(documents, minDocumentsAttached),
      message: t("requests.submission.upload.minDocumentsAttached"),
    };
  }, [minDocumentsAttached, documents, t]);

  useEffect(() => {
    const subscriber = subscribe("validate-document-upload", () => {
      return validate();
    });
    return () => unsubscribe(subscriber);
  }, [validate]);

  return (
    <div className={`${className}`}>
      {documents.map((doc, index) => (
        <Document
          key={`doc${index}`}
          index={index}
          uploadStatus={doc.uploadStatus}
          renderDocumentTitle={() => (
            <DocumentTitle
              index={index}
              required={doc.required}
              label={doc.label}
              link={doc.link}
              dispatchUpdateAction={dispatchUpdateAction}
              documents={documents}
              size={titleSize}
            />
          )}
          renderDocumentUploadProgress={() => (
            <DocumentUploadProgress doc={doc} dispatchUpdateAction={dispatchUpdateAction} />
          )}
          renderDocumentUploadButton={() => (
            <DocumentUploadButton
              doc={doc}
              uploadUrl={uploadUrl}
              maxDocumentSizeInMb={maxDocumentSizeInMb}
              acceptDocumentTypes={acceptDocumentTypes}
              dispatchUpdateAction={dispatchUpdateAction}
              handleResponse={handleResponse}
              formDataAsJson={formDataAsJson}
            />
          )}
        />
      ))}
      <AddDocument documents={documents} dispatchUpdateAction={dispatchUpdateAction} />
    </div>
  );
}

export default DocumentUpload;
